import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "mothistory2",
  class: "pb-20 pt-20"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-3-md d-none d-block-md p-30 pt-0 text-center" }
const _hoisted_4 = { class: "col-9-md" }
const _hoisted_5 = {
  key: 0,
  class: "text-center"
}
const _hoisted_6 = { class: "row mt-20 centered" }
const _hoisted_7 = {
  key: 0,
  class: "mb-10 col-2-sm col-4 mh__result mh__result--pass"
}
const _hoisted_8 = {
  key: 1,
  class: "mb-10 col-2-sm col-4 mh__result mh__result--fail"
}
const _hoisted_9 = { class: "mb-10 col-4-sm col-8" }
const _hoisted_10 = { class: "mh__value" }
const _hoisted_11 = { class: "mb-10 col-2-sm col-4" }
const _hoisted_12 = { class: "mh__value" }
const _hoisted_13 = { class: "mb-10 col-4-sm col-8" }
const _hoisted_14 = { class: "mh__value" }
const _hoisted_15 = { class: "row s-row pb-20" }
const _hoisted_16 = {
  key: 0,
  class: "offset-2-sm col-10-sm"
}
const _hoisted_17 = { class: "mh__reasons" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 1,
  class: "offset-2-sm col-10-sm"
}
const _hoisted_20 = { class: "mh__reasons" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  key: 2,
  class: "offset-2-sm col-10-sm"
}
const _hoisted_23 = { class: "mh__reasons" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 3,
  class: "offset-2-sm col-10-sm"
}
const _hoisted_26 = { class: "mh__reasons" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 4,
  class: "offset-2-sm col-10-sm"
}
const _hoisted_29 = { class: "mh__reasons" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = {
  key: 2,
  class: "text-left"
}
const _hoisted_32 = {
  key: 3,
  class: "pt-20 pb-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_graph = _resolveComponent("graph")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-bold mb-30" }, "MOT status:", -1 /* CACHED */)),
        _createVNode(_component_graph, {
          small: false,
          expired: _ctx.isExpired,
          days: _ctx.daysLeft,
          label: "MOT"
        }, null, 8 /* PROPS */, ["expired", "days"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "panel-header text-center" }, " MOT history ", -1 /* CACHED */)),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Loading... "))
          : _createCommentVNode("v-if", true),
        (_ctx.mot.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.mot, (item) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_6, [
                  (item.result === 'Pass')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.result), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (item.result !== 'Pass')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.result), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mh__title" }, " Date tested ", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.cleanDate(item.mot_date)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mh__title" }, " Mileage ", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatThousandsWithRounding(parseInt(item.odometer_reading), 0)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mh__title" }, " Expiry date ", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.cleanDate(item.exp_date)), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (item.comments && item.comments.reason && item.comments.reason.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mh__reason-cat" }, "Reason(s) for failure:", -1 /* CACHED */)),
                        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("ul", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.comments.reason, (advice) => {
                            return (_openBlock(), _createElementBlock("li", { innerHTML: advice }, null, 8 /* PROPS */, _hoisted_18))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (item.comments.dangerous && item.comments.dangerous.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mh__reason-cat" }, "Dangerous failure(s):", -1 /* CACHED */)),
                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("ul", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.comments.dangerous, (advice) => {
                            return (_openBlock(), _createElementBlock("li", { innerHTML: advice }, null, 8 /* PROPS */, _hoisted_21))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (item.comments.major && item.comments.major.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mh__reason-cat" }, "Major failure(s):", -1 /* CACHED */)),
                        _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("ul", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.comments.major, (advice) => {
                            return (_openBlock(), _createElementBlock("li", { innerHTML: advice }, null, 8 /* PROPS */, _hoisted_24))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (item.comments.minor && item.comments.minor.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "mh__reason-cat" }, "Minor failure(s):", -1 /* CACHED */)),
                        _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("ul", _hoisted_26, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.comments.minor, (advice) => {
                            return (_openBlock(), _createElementBlock("li", { innerHTML: advice }, null, 8 /* PROPS */, _hoisted_27))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (item.comments.advice && item.comments.advice.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "mh__reason-cat" }, "Advisory notice item(s):", -1 /* CACHED */)),
                        _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("ul", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.comments.advice, (advice) => {
                            return (_openBlock(), _createElementBlock("li", { innerHTML: advice }, null, 8 /* PROPS */, _hoisted_30))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        (_ctx.failed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, " Unfortunately our system cannot find any MOT history for this vehicle. "))
          : _createCommentVNode("v-if", true),
        (_ctx.expired && _ctx.mot)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [...(_cache[14] || (_cache[14] = [
              _createElementVNode("div", { class: "alert alert--danger" }, [
                _createElementVNode("strong", null, "This vehicle's MOT has expired"),
                _createElementVNode("br"),
                _createTextVNode(" You can be fined up to £1000 for driving without a valid MOT. ")
              ], -1 /* CACHED */)
            ]))]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ], 512 /* NEED_PATCH */)), [
    [_vShow, _ctx.active]
  ])
}